import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { GetEquipmentsWorkRequestsList } from '../../../store/FLEET/EquipmentsWorkRequests/equipmentsWorkRequestSlice';
import { CardBody, Card } from '../../../components/card/card';
import Breadcrumb from '../../../components/Shared/Breadcrumb';
import NtxTable from '../../../components/DataTable/NtxTable';
import ModalComponent from '../../../components/Modal/ModalComponent';
// import OrderMaintenanceForm from '../WorkOrder/OrderMaintenanceForm';

interface props {
  // setID: React.Dispatch<React.SetStateAction<string>>; // For Update
}

const WorkRequestList: React.FC<props> = (props) => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const Navigate = useNavigate();

  useEffect(() => {
    dispatch(GetEquipmentsWorkRequestsList());
  }, []);
  const { EquipmentsWorkRequestsList } = useAppSelector((state) => state.EquipmentsWorkRequest);

  const columns = [
    { title: t('RequestNumber'), key: 'RequestNumber' },
    { title: t('RequestDate'), key: 'RequestDate' },
    { title: t('Equipment'), key: 'Equipment' },
    { title: t('TypeOfRequest'), key: 'TypeOfRequest' },
    { title: t('RequestDescription'), key: 'RequestDescription' },
    { title: t(''), key: 'action', className: 'text-end' },
  ];

  const tableData = EquipmentsWorkRequestsList?.map((item) => {
    let rowClass;

    return {
      RequestNumber: item.requestCode,
      TypeOfRequest: i18n.language === 'ar' ? item.requestTypeName2 : item.requestTypeName,
      RequestDescription: item.requestTitle,
      RequestDate: item.requestDate,
      Equipment: i18n.language === 'ar' ? item.fleetEquipmentsName2 : item.fleetEquipmentsName,

      action: (
        <button
          type="button"
          className="btn btn-sm btn-outline-theme"
          data-bs-toggle="modal"
          data-bs-target="#ModalAddOrderMaintenance"
          //  onClick={() => Navigate(`${item.id}/AddMaintenanceOrder/${item.fleetEquipmentsId}`)}
        >
          {/* <i className="far fa-lg fa-fw me-2 fa-edit"></i> */}
          <i className="  fa-lg fa-fw me-2 fas fa-wrench"></i>
          {t('MaintenanceOrder')}
        </button>
      ),

      rowClass, // استخدم rowClass هنا
    };
  });

  //________________________________
  var BcrumbList = [
    {
      name: 'Home',
     link: ':moduleHome',
    },
    {
      name: 'MaintenanceOrders',
      link: '/FLEET/Maintenance/MaintenanceOrder',
    },
    {
      name: 'MaintenanceRequests',
      link: null,
    },
  ];

  return (
    <>
      <div className="d-flex align-items-center">
        <Breadcrumb BreadcrumbList={BcrumbList} PageName="MaintenanceRequests" />
        <div className="ms-auto">
          <button type="button" className="btn btn-secondary" onClick={() => Navigate(-1)}>
            {t('Back')}
            {i18n.language === 'en' ? (
              <i className="fa fa-arrow-right fa-fw ms-2 fs-5"></i>
            ) : (
              <i className="fa fa-arrow-left fa-fw ms-2 fs-5"></i>
            )}
          </button>
        </div>
      </div>
      <Card>
        <CardBody>
          <NtxTable
            data={tableData || []}
            columns={columns}
            dataPerPage={10}
            theadClass=""
            tableClass="table text-nowrap table-hover "
            enableSearch
            showRecordsSelector
          />
        </CardBody>
      </Card>

      {/* <ModalComponent title={t('MaintenanceOrder')} id="ModalAddOrderMaintenance">
        {<OrderMaintenanceForm />}
      </ModalComponent> */}
    </>
  );
};

export default WorkRequestList;
